
import {Options, Vue} from "vue-class-component"
import {Watch} from "vue-property-decorator"
import {ref} from "@vue/reactivity"
import InputNumber from "primevue/inputnumber"

@Options({
  name: "AnimatedNumberInput",
  //@ts-ignore
  props: {
    label: String,
    placeholder: String,
    modelValue: Number,
    inline: Boolean,
    error: String,
    disabled: Boolean,
    name: String,
    autofocus: Boolean,
    small: Boolean,
    noBackground: Boolean,
    required: Boolean
  },
  components: {
    InputNumber
  }
})
export default class AnimatedInput extends Vue {
  label!: string
  placeholder!: string
  modelValue!: number
  inline!: boolean
  error!: string
  disabled!: boolean
  name!: string
  autofocus!: boolean
  small!: boolean
  noBackground!: boolean
  required!: boolean

  focused = false
  internalValue: number = this.modelValue || 0

  //@ts-ignore
  myinput: HTMLInputElement = ref<HTMLInputElement | null>(null)

  get animationClass (): string {
    if (this.noBackground) {
      return 'bg-white' + this.sizeClass + this.inlineClass
    } else if (this.focused || (this.internalValue && this.internalValue !== 0)) {
      return 'ai-filled' + this.errorClass + this.sizeClass + this.inlineClass
    } else {
      return '' + this.errorClass + this.sizeClass + this.inlineClass
    }
  }

  get inlineClass (): string {
    return (this.inline ? ' animated-input-inline' : '')
  }

  get sizeClass(): string {
    return (this.small ? ' animated-input-sm' : '')
  }

  get errorClass(): string {
    if (this.error) {
      if (this.focused) {
        return ' border-danger'
      } else {
        return ' border-danger danger'
      }
    } else {
      return ''
    }
  }

  handleFocus () {
    this.focused = true
    this.$emit('focus')
  }

  handleBlur () {
    this.focused = false
    this.$emit('blur')
  }

  handleKeypress (event: KeyboardEvent) {
    if ('Enter' === event.code) {
      this.$emit('submit', this.internalValue || '')
    }
  }

  checkAutofill(e : AnimationEvent) {
    if (e.animationName === "onAutoFillStart") this.$emit("autofill", true)
    else if (e.animationName === "onAutoFillCancel") this.$emit("autofill", false)
  }

  @Watch('internalValue')
  onInternalValueChanged (val: number, /* oldVal: number */) {
    this.$emit('update:modelValue', this.internalValue || '')
  }

  @Watch('modelValue')
  onModelValueChanged (val: number, /* oldVal: number */) {
    this.internalValue = val || 0
  }

  //Do things when we're in the dom:
  mounted () {
    if (this.autofocus) {
    }
  }
}
